export default __webpack_public_path__ + "static/media/P207.1.fc6819f7.mp3";